module.exports = __webpack_public_path__ + "img/dept-9.85f211ef.svg";